export const RECOVERY_VERSION_KEY = (workspaceId: string) =>
  `sl_recovery_version_${workspaceId}`;

export interface WorkspaceRecoveryVersionCheck {
  serverVersion: number;
  localVersionStr: string | null;
  hasLocalWorkspaceDatabases: boolean;
}

/**
 * First-time visitors do not have a local recovery marker. If they also do not
 * have local workspace databases, there is nothing stale to clear.
 */
export function shouldRefreshLocalWorkspaceCache({
  serverVersion,
  localVersionStr,
  hasLocalWorkspaceDatabases,
}: WorkspaceRecoveryVersionCheck): boolean {
  if (!Number.isFinite(serverVersion) || serverVersion <= 0) {
    return false;
  }

  if (localVersionStr === null) {
    return hasLocalWorkspaceDatabases;
  }

  const localVersion = Number.parseInt(localVersionStr, 10);
  if (!Number.isFinite(localVersion)) {
    return hasLocalWorkspaceDatabases;
  }

  return serverVersion > localVersion;
}
